import * as React from "react";
const LowImpactSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.04}
      strokeWidth={8}
      rx={24}
    />
    <g clipPath="url(#a)">
      <path
        fill="#EF4136"
        d="m41.937 26.797-1.532-3.828a1.742 1.742 0 0 0-1.623-1.094H35V21a.875.875 0 0 0-.875-.875H17.5a1.75 1.75 0 0 0-1.75 1.75v12.25a1.75 1.75 0 0 0 1.75 1.75h1.86a3.5 3.5 0 0 0 6.78 0h5.47a3.5 3.5 0 0 0 6.78 0h1.86a1.75 1.75 0 0 0 1.75-1.75v-7a.868.868 0 0 0-.063-.328ZM35 23.625h3.782l1.05 2.625H35v-2.625Zm-17.5-1.75h15.75v7H17.5v-7Zm5.25 14.875a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Zm8.86-2.625h-5.47a3.5 3.5 0 0 0-6.78 0H17.5v-3.5h15.75v1.346a3.513 3.513 0 0 0-1.64 2.154ZM35 36.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Zm5.25-2.625h-1.86A3.507 3.507 0 0 0 35 31.5V28h5.25v6.125Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M14 14h28v28H14z" />
      </clipPath>
    </defs>
  </svg>
);
export default LowImpactSVG;
